const { getTranslationDictionary } = require('core');

module.exports = function documentTypeToIcon(type) {
	const translationDictionary = getTranslationDictionary();
    switch(type) {
        case 'PP':
            return translationDictionary.publicPicture;
        case 'FR':
            return translationDictionary.waybill;
        default:
            return translationDictionary.unknownDocument;
    }
};
